import { State } from '@hookstate/core';
import React from 'react';
import { AwaySunlightIcon } from '../../../../static/svg/AwaySunlightIcon';
import { ExternalUseIcon } from '../../../../static/svg/ExternalUseIcon';
import { SkinTypeIcon } from '../../../../static/svg/SkinTypeIcon';
import { attributesType } from '../../../components/libs/typeInterface';
import { currencySymbols } from '../../constants';

interface IInnerDetails {
  name: string;
  size: string;
  shortDesc: string;
  attributes: attributesType[];
  price: number;
  mrp: number;
  link: string;
  openRedirectModal: State<boolean>;
  productType?: string;
}
const InnerDetails = (props: IInnerDetails) => {
  const { name, size, shortDesc, attributes, price, mrp, link, openRedirectModal, productType } =
    props;

  function openStore(proLink: string) {
    openRedirectModal.set(true);
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    setTimeout(function () {
      document.getElementsByTagName('body')[0].removeAttribute('style');
      openRedirectModal.set(false);
      window.location.href = proLink;
    }, 5000);
  }

  return (
    <>
      <div className="xs:w-full lg:w-4/5 flex flex-col items-start justify-start">
        <p className="text-customColors-200 font-breadley-sans xs:text-3xl lg:text-5xl">
          R&G {name.toLowerCase() === 'facewash' ? `` : `Face `}
          {name}
        </p>
        <p className={`text-sm${productType === 'kit' ? ' mt-2.5' : ' mt-1.5'}`}>{size}</p>
        <p className="text-base mt-5">{shortDesc}</p>
        <div className="w-full mt-3 flex flex-wrap items-start justify-between space-y-3">
          {attributes.map((item, index) => (
            <div key={index} className="w-auto flex flex-nowrap items-center justify-start mt-3">
              {item.icon === 'skin' && <SkinTypeIcon className="w-8 h-8" />}
              {item.icon === 'external' && <ExternalUseIcon className="w-8 h-8" />}
              {item.icon === 'away' && <AwaySunlightIcon className="w-8 h-12" />}
              <p className="ml-2">{item.value}</p>
            </div>
          ))}
        </div>
        <div className="w-full flex items-center justify-start flex-wrap my-5">
          <p className="text-lg">
            MRP :{' '}
            <del className="text-red-500 font-normal">
              {currencySymbols.rupee}
              {mrp}
            </del>
            <span className="text-xl font-semibold ml-1">
              {currencySymbols.rupee}
              {price}
            </span>
          </p>
          <p className="w-full text-customColors-300 text-sm">Incl. of all taxes</p>
        </div>
        <a
          onClick={() => {
            openStore(link);
          }}
          target="_blank"
          className="cursor-pointer xs:w-full lg:w-4/5 py-2 text-customColors-300 xs:text-sm lg:text-xl text-center uppercase rounded-sm z-10 transition-all duration-300 shop-now shade-0"
        >
          {/* Buy Now */}
          Know More
        </a>
      </div>
    </>
  );
};

export default InnerDetails;
